import api from "../api/api";
import IZoningFilter from "../interfaces/IZoningFilter";

export default class ZoningFiltersApiService {
    public async getZoningFilters(): Promise<IZoningFilter[]> {
        const response = await api.get<IZoningFilter[]>("/zoningfilter/get");
        return this.mapZoningFilters(response.data);
    }

    private mapZoningFilters(data: any): IZoningFilter[] {
        return data.map((zf: any) => ({
            name: zf.name,
            geoid: zf.geoid.toString(),
            municipality: zf.municipality,
            zonings: zf.zones,
            color: zf.color,
        }));
    }
}